import styled from '@emotion/styled';
import type { PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import { IconMap } from '../../../Icon';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';

function MapLinkColComponent({
  starterInfo,
  event,
}: {
  starterInfo: Immutable<PreparedStarterInfo>;
  event: Immutable<RacemapEvent>;
}) {
  const eventSlug = event.slug;

  return (
    <Cell>
      <Link
        href={`/player/${eventSlug}#${
          starterInfo.results[0]?.time != null && !event.modules.netReplay.enabled
            ? `time=${new Date(starterInfo.results[0]?.time).toISOString()}&`
            : ''
        }selected=${starterInfo?.id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconMap />
      </Link>
    </Cell>
  );
}

export function getMapLinkCol(event: Immutable<RacemapEvent>): Column {
  return {
    key: 'map-link',
    title: '',
    width: 70,
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return <MapLinkColComponent starterInfo={row} event={event} />;
    },
  };
}

const Link = styled.a`
  .icon-svg {
    height: 20px;
  }
`;
